import i18n from 'i18next';

export type WorkloadStatus = 'ON_TRACK' | 'BALANCED' | 'SUSTAINED' | 'UNDER_PRESSURE' | 'OVERLOADED';
export type ProjectHealth = 'ON_TRACK' | 'AT_RISK' | 'OFF_TRACK';
export type ProjectStatus = 'PLANNING' | 'ACTIVE' | 'COMPLETED' | 'ON_HOLD';
export type TaskStatus = 'TODO' | 'IN_PROGRESS' | 'REVIEW' | 'COMPLETED';
export type PillStatus = WorkloadStatus | ProjectHealth | ProjectStatus | TaskStatus | 'ACTIVE_TENANT' | 'SUSPENDED' | 'INVITED' | 'DISABLED' | 'PLANNED' | 'CLOSED';

type Tone = 'primary' | 'success' | 'warn' | 'risk' | 'ink' | 'neutral';

/** Tone per status; the label comes from the `status.*` translations. */
export const STATUS_TONE: Record<PillStatus, Tone> = {
  ON_TRACK: 'success',
  BALANCED: 'ink',
  SUSTAINED: 'primary',
  UNDER_PRESSURE: 'warn',
  OVERLOADED: 'risk',
  AT_RISK: 'risk',
  OFF_TRACK: 'risk',
  PLANNING: 'ink',
  ACTIVE: 'primary',
  COMPLETED: 'success',
  ON_HOLD: 'warn',
  TODO: 'neutral',
  IN_PROGRESS: 'primary',
  REVIEW: 'warn',
  ACTIVE_TENANT: 'success',
  SUSPENDED: 'risk',
  INVITED: 'warn',
  DISABLED: 'neutral',
  PLANNED: 'ink',
  CLOSED: 'neutral'
};

export const statusLabel = (status: PillStatus): string => i18n.t(`status.${status}`);
